module.exports = __webpack_public_path__ + "img/pwa-ico-512.606f3fb6.png";